export default __webpack_public_path__ + "assets/images/Dashboard Menu Icon-a3ba7b4feb34371c19829be84026b0db.svg";